const e = [10, 20, 50, 100];
export {
  e as pageSizeOptions
};
//# sourceMappingURL=constants.js.map
